/**
 * Fichier de configuration pour l'application
 */
const config = {
    helpUrl: "https://localhost:3000/help.html"
};

export default config;